export default __webpack_public_path__ + "static/astra-zeneca-11ca8745a12c309dcd2f6b60098b79e5.png";